export { default } from './GoalTemplateDetailsModalDucks'
export * from './GoalTemplateDetailsModalDucks'
